import { useEffect, useState } from "react";
import NotificationService from "../../services/notification";
import NotificationCard from "./notifCard";
import NotificationDetailModal from "./notifModal";
import { IoIosClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";

function Notification({ isOpen, onClose }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedNotification, setSelectedNotification] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isOpen) return;

    async function getNotifications() {
      try {
        setLoading(true);
        setError("");

        const response = await NotificationService.NotificationList({});
        setNotifications(response.data.data.docs);
      } catch (err) {
        setError("Failed to get notifications");
      } finally {
        setLoading(false);
      }
    }

    getNotifications();
  }, [isOpen]);
  function handleNotificationClick(notification) {
    console.log(notification.ticket_id);

    if (notification.ticket_id) {
      navigate(`/support/${notification.ticket_id}`);
    } else {
      setSelectedNotification(notification);
    }
  }

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-[90] bg-black/40" onClick={onClose} />

      <div className="fixed right-0 top-0 z-[100] h-full w-full max-w-md bg-white shadow-xl flex flex-col">
        <div className="flex items-center justify-between p-5 border-b">
          <h2 className="font-bold text-lg">Notifications</h2>

          <IoIosClose
            onClick={onClose}
            className="text-2xl cursor-pointer text-gray-500"
          />
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          {loading ? (
            <p className="text-center py-8">Loading...</p>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : notifications.length === 0 ? (
            <p className="text-center text-gray-500 py-8">No notifications</p>
          ) : (
            <div className="flex flex-col gap-3">
              {notifications.map((notification) => (
                <NotificationCard
                  key={notification._id}
                  notification={notification}
                  onClick={() => handleNotificationClick(notification)}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {selectedNotification && (
        <NotificationDetailModal
          notification={selectedNotification}
          onClose={() => setSelectedNotification(null)}
        />
      )}
    </>
  );
}

export default Notification;
